import { render, staticRenderFns } from "./HotelFacilities.vue?vue&type=template&id=9d679d08"
import script from "./HotelFacilities.vue?vue&type=script&lang=js"
export * from "./HotelFacilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelFacility: require('/vercel/path0/components/partials/HotelFacility.vue').default})
